import script from "./VMunicipalEntitiesSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./VMunicipalEntitiesSelect.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__